import {
    Browser,
    Cards,
    Cube,
    Gear,
    Shapes,
} from '@phosphor-icons/react/dist/ssr';

import type { IntegrationSideContentTemplateProps } from '@/components/templates/IntegrationSideContentTemplate';

export const INTEGRATION_SIDE_CONFIG: IntegrationSideContentTemplateProps = {
    listData: [
        {
            title: 'Materiały developerskie',
            id: '1',
            list: [
                {
                    id: '1',
                    name: 'Moduły',
                    Icon: Cube,
                    iconProps: {
                        'aria-hidden': 'true',
                    },
                    href: '/nowy-biznes/integracja/materialy-developerskie-moduly',
                },
                {
                    id: '2',
                    name: 'API',
                    Icon: Gear,
                    iconProps: {
                        'aria-hidden': 'true',
                    },
                    href: '/nowy-biznes/integracja/materialy-developerskie-api',
                },
            ],
        },
        {
            title: 'Materiały marketingowe',
            id: '2',
            list: [
                {
                    id: '1',
                    name: 'Karta produktu',
                    Icon: Cards,
                    iconProps: {
                        'aria-hidden': 'true',
                    },
                    href: '/nowy-biznes/integracja/komunikacja-stala-karta-produktu/',
                },
                {
                    id: '2',
                    name: 'Landing page',
                    Icon: Browser,
                    iconProps: {
                        'aria-hidden': 'true',
                    },
                    href: '/nowy-biznes/integracja/komunikacja-stala-landing-page/',
                },
                {
                    id: '3',
                    name: 'Logotypy',
                    Icon: Shapes,
                    iconProps: {
                        'aria-hidden': 'true',
                    },
                    href: '/nowy-biznes/integracja/komunikacja-stala-logotyp/',
                },
            ],
        },
    ],
};
